import * as React from 'react';
export const IcServerWifi = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.23 12.77a1 1 0 00-.45-1.34l-.4-.18a3.942 3.942 0 00-3.17.18 1.002 1.002 0 10.9 1.79 1.86 1.86 0 011.56-.09c.076.024.15.054.22.09a1 1 0 00.45.11 1 1 0 00.89-.56zM18 14a1 1 0 100 2 1 1 0 000-2zM5.5 11h6.59A6 6 0 0118 6h3.65a3.49 3.49 0 00-3.15-2h-13a3.5 3.5 0 100 7zm4-4.5a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2zm6.59 6.5H5.5a3.5 3.5 0 100 7h13a3.49 3.49 0 003.15-2H18a6 6 0 01-5.91-5zM5.5 17.5a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm12.08-7.41a1 1 0 00-.45-1.35 7 7 0 00-6.26 0 1.001 1.001 0 10.9 1.79 5 5 0 014.46 0 1 1 0 001.35-.44z'
      fill='currentColor'
    />
  </svg>
);
